"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
exports.default = {
    fetch: function (query, callback) {
        if (callback === void 0) { callback = function (data) { }; }
        axios_1.default.post('/data/vacancies', query).then(function (response) {
            // TODO fix
            // Globals.set(response.data);
            callback(response.data);
        });
    },
    registerVisit: function (vacancyId) {
        // TODO check if this can be combined with fetching data for a Vacancy, as then you have probably visited the Vacancy right?
        axios_1.default.post("/data/vacancies/".concat(vacancyId, "/visit"));
    },
    registerLike: function (vacancyId) {
        axios_1.default.post("/data/vacancies/".concat(vacancyId, "/like"));
    },
};
